<div class="container-fluid">
  <div class="my-5 ms-0 ms-md-2 ms-lg-4 ms-xl-5">
    <div class="d-flex flex-column flex-md-row">
      <div>
        <i-feather class="success-icon me-4 mb-4"
                   name="check-circle">
        </i-feather>
      </div>
      <div>
        <div class="row">
          <div class="col-12 col-md-9 col-xl-7">
            <h1 class="pre-wrap mb-3"
                [translate]="'AUTH.CREATE-ACCOUNT-SUCCESS.PAGE-TITLE'">
            </h1>
            <p class="mb-5">
              <span class="pre-wrap"
                    [translate]="'AUTH.CREATE-ACCOUNT-SUCCESS.PAGE-DESCRIPTION'"></span>
              <a [translate]="'AUTH.CREATE-ACCOUNT-SUCCESS.LINK-CUSTOMER-ACCOUNT-TEXT'"
                 href="#"
                 (click)="goToCustomerAccount(); false"></a>
            </p>
          </div>
        </div>
        <button type="button"
                class="btn btn-outline-primary"
                (click)="goBack()"
                [translate]="'AUTH.CREATE-ACCOUNT-SUCCESS.BUTTON-RETURN-TEXT'">
        </button>
      </div>
    </div>
  </div>
</div>
